export default {"src":"/_next/static/media/arrow_down.250b187e.svg","height":15,"width":15,"blurWidth":0,"blurHeight":0};